export default class information{
    constructor(kv){

        this.kv = kv;
        this.yoyo;

    }

    btnShow(){

        TweenMax.to(this.kv.informationBtn, 0.3, {
            opacity: 1,
            display:'block',
            ease: Sine.easeOut
        });

    }

    btnHide(){

        TweenMax.to(this.kv.informationBtn, 0.3, {
            opacity: 0,
            display:'none',
            ease: Sine.easeOut
        });

    }

    show(){

        TweenMax.set(this.kv.information, {
            opacity: 1,
            display: 'block',
            scale:1,
        });
        TweenMax.set(this.kv.information.querySelector('.line'), {
            opacity: 0,
            display: 'none'
        });

        if(!Useragnt.mobile && !Useragnt.tablet) {

            TweenMax.fromTo(this.kv.informationInner, 0.1, {
                width: '0px',
                height: '0px',
                x: '195px',
                y: '42px',
            }, {
                width: '20px',
                height: '85px',
                x: '185px',
                y: '0px',
                ease: Power3.easeOut,
                onComplete: () => {
                    TweenMax.to(this.kv.informationInner, .8, {
                        width: '390px',
                        height: '85px',
                        x: '0px',
                        ease: Power3.easeOut,
                    });
                    if (this.yoyo) {
                        this.yoyo.play();
                    } else {
                        this.yoyo = TweenMax.to(this.kv.information, 0.95, {
                            y: '-8px',
                            repeat: -1,
                            yoyo: true,
                            ease: Power0.easeOut,
                            onComplete: () => {
                                TweenMax.to(this.kv.information, 0.95, {
                                    y: '8px',
                                    ease: Power0.easeOut,
                                });
                            }
                        });
                    }
                    TweenMax.fromTo(this.kv.information.querySelector('.line'), 0.1, {
                        x: '10px',
                        opacity: 0,
                        display: 'none',
                    }, {
                        delay: 0.3,
                        x: '0px',
                        opacity: 1,
                        display: 'block',
                        ease: Power3.easeOut
                    });
                }
            });
            TweenMax.fromTo(this.kv.informationInner.querySelector('dl'), 0.1, {
                x: '195px',
                y: '42px',
            }, {
                x: '0px',
                y: '0px',
                ease: Power3.easeOut
            });

        }else{

            TweenMax.set(this.kv.informationInner.querySelector('dl'), {
                opacity: 0,
                display: 'none'
            });

            TweenMax.fromTo(this.kv.informationInner, 0.4, {
                opacity: 0,
                display: 'none',
            }, {
                opacity: 1,
                display: 'block',
                ease: Power3.easeOut,
                onComplete: () => {
                    TweenMax.fromTo(this.kv.informationFace, 0.4, {
                        opacity: 1,
                        scale:0.8,
                    }, {
                        scale: 1,
                        opacity: 1,
                        ease: this.kv.easeBack
                    });
                    TweenMax.fromTo([this.kv.informationInner.querySelector('dl'),this.kv.information.querySelector('.line')], 0.4, {
                        scale:0.8,
                        opacity: 0,
                        display: 'none',
                    }, {
                        scale: 1,
                        opacity: 1,
                        display: 'block',
                        ease: this.kv.easeBack
                    });
                }
            });

        }

    }

    hide(){

        if(!Useragnt.mobile && !Useragnt.tablet) {
            TweenMax.to(this.kv.information, 0.3, {
                opacity: 0,
                display:'none',
                ease: this.kv.easeBack
            });

            if(this.yoyo){
                this.yoyo.pause();
            }
        }else{
            TweenMax.to(this.kv.information, 0.3, {
                opacity: 0,
                display: 'none',
                ease: this.kv.easeBack
            });
            TweenMax.to(this.kv.informationFace, 0.3, {
                opacity: 0,
                ease: this.kv.easeBack
            });
            TweenMax.to([this.kv.informationInner.querySelector('dl'),this.kv.information.querySelector('.line')], 0.3, {
                scale:0.8,
                opacity: 0,
                display: 'none',
                ease: this.kv.easeBack
            });
        }


    }


}